<template>
    <div class="vf-view__container bg-white">
        <slot />
    </div>
</template>

<script>
export default {};
</script>

<style scoped>
.vf-view__container {
    padding: 36px;
    border-radius: 6px;
    box-shadow: 0 3px 8px rgba(34, 48, 62, 0.1);
}
</style>
